<template>
<div class="check-box">
  <!-- 最外层复选框不能点击 -->
  <div v-if="!isClickCheck">
    <label :class="['el-checkbox',checkAllvalue?'is-checked':'']">
      <span :class="['el-checkbox__input', checkAllvalue?'is-checked':'',indeterminateValue?'is-indeterminate':'']">
        <span class="el-checkbox__inner"></span>
        <input type="checkbox" aria-hidden="false" class="el-checkbox__original" value="">
      </span>
    </label>
  </div>
  <!-- 最外层复选框可以点击 -->
  <el-checkbox v-else v-model="checkAllvalueClick" size="mini" :indeterminate="indeterminateValue" :checkIndeterminate="checkIndeterminate" @change="checkAllCurrent"> </el-checkbox>
  <el-popover placement="bottom" trigger="click" popper-class="check-popover">
    <p class="check-item" v-for="(item,index) in checkList" :key="index">
      <!-- 带复选框 -->
      <span @click="eventChange(item,item.methods,form[item.key])" :key="item.value">
        {{ item.lable }}
      </span>
    </p>
    <div slot="reference" class="check-wrap">
      <span><i class="el-icon-arrow-down check-icon"></i></span>
    </div>
  </el-popover>
</div>
</template>

<script>
export default {
  props: {
    checkAll: { //点击外层复选框选中状态值
      type: Boolean,
      default: false
    },
    checkForm: {
      type: Object,
      default: {}
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    isClickCheck: {
      type: Boolean,
      default: false
    },
    checkIndeterminate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // checkAllvalue:this.checkAll,
      checkList: [{
          value: '2',
          lable: this.$i18.language('全选所有'),
          key: 'allContact',
          methods: 'getAllContactCheck',
          indeterminate: 'indeterminateAll'
        },
        {
          value: '1',
          lable: this.$i18.language('全选当页'),
          key: 'currentContact',
          methods: 'getCurrentContactCheck',
          indeterminate: 'indeterminateCurrent'
        },
        {
          value: '3',
          lable: this.$i18.language('清空所有'),
          key: 'clearAllContact',
          methods: 'clearAllContactCheck'
        },
      ],
      form: this.checkForm,
      checkAllvalueClick: this.checkAll
    }
  },
  computed: {
    //选中状态
    checkAllvalue() {
      let flag = false
      if (this.checkForm.allContact || this.checkForm.currentContact) {
        flag = true
      }
      return flag
    },
    indeterminateValue() {
      let flag = false
      if (this.checkForm.indeterminateCurrent || this.checkForm.indeterminateAll) {
        flag = true
      }
      return flag
    }
  },
  methods: {
    eventChange(data, methodsWords, val) {
      //点击当前val设置为true
      val = true //是带复选框就可以不需要
      this.$emit('eventChange', data, methodsWords, val)
    },
    checkAllCurrent() {
      this.$emit('changeAllCheck', this.isClickCheck ? this.checkAllvalueClick : this.checkAllvalue)
    }
  }
}
</script>

<style lang="scss" scoped>
.check-box {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px 3px 3px 3px;
  cursor: pointer;

  .check-icon {
    margin-left: 5px;
  }

}

.check-item {
  span {
    display: block;
    padding: 8px 10px;
    cursor: pointer;
    font-size: 12px;
  }

  &:first-child {
    span {
      border-radius: 4px 4px 0 0;
    }
  }

  &:last-child {
    span {
      border-radius: 4px 4px 0 0 !important;
    }
  }

  .active-text {
    background: #FDEEE8;
    color: #EA5519;
  }

  .default-text {
    color: #333333;
    // background: #FFFFFF;
  }

}

.checkbox {
  height: 12px;
  width: 12px;
  line-height: 12px;
  // border: 1px solid #DCDFE6;
  display: inline-block;
  // border-radius: 2px;
  background-color: #FFFFFF;
}

.check-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: -2px;
}

.disabled-btn {
  color: #9FA9BA !important;
  background-color: #F7F7F7 !important;
}
</style><style lang="scss">
.check-popover {
  padding: 0 !important;
  min-width: 71px !important;
  border: 1px solid #E4E7ED !important;
  border-radius: 4px !important;

  .popper__arrow {
    display: block !important;
  }
}
</style>
